import qs from "qs";
import type { CompanyInfo } from "../../../api/clientsManagementTypes";

const BUSINESS_CENTRAL_ORIGIN = "https://businesscentral.dynamics.com";
const FUND_OPS_PROFILE = "EAC Fund Accountant";

export const getFundOpsUrl = (company: CompanyInfo): string | undefined => {
  const { bcTenantId, bcEnvironment, bcCompanyName } = company;
  if (!bcTenantId || !bcEnvironment || !bcCompanyName) {
    return undefined;
  }
  const query = qs.stringify({ company: bcCompanyName, profile: FUND_OPS_PROFILE });
  return `${BUSINESS_CENTRAL_ORIGIN}/${bcTenantId}/${bcEnvironment}?${query}`;
};
